export const getColumnVisibilityKey = (tableId: string) =>
  `data-table-visibility-${tableId}`

// Column order state per table
export const getColumnOrderKey = (tableId: string) =>
  `data-table-column-order-${tableId}`

// Controls panel open/close state (global)
export const CONTROLS_KEY = 'data-table-controls'

// Duties Metrics filter rail open/close state. Deliberately not CONTROLS_KEY:
// that one is shared by every data table and defaults to collapsed, whereas
// this dashboard's rail defaults to open.
export const DUTIES_METRICS_FILTER_RAIL_KEY = 'duties-metrics-filter-rail'
